<template>
  <div class="flex min-w-0 items-center gap-1 text-label">
    <sms-status v-if="item.status" :status="item.status" class="shrink-0" />
    <provider-image :provider="item.provider" alt="SMS Provider Icon" />
    <template v-if="item.is_outgoing">
      <span
        v-if="item.sender?.name"
        v-tooltipable.collapsed="item.from"
        class="min-w-0 truncate"
      >
        {{ item.sender.name }}
      </span>
      <template v-if="item.receiver?.name">
        <span class="shrink-0 whitespace-nowrap">
          {{ $t("COMMON.SMS") }} {{ $t("COMMON.TO").toLowerCase() }}:
        </span>
        <span v-tooltipable.collapsed="item.to" class="min-w-0 truncate">
          {{ item.receiver.name }}
        </span>
      </template>
    </template>
    <template v-else-if="item.sender?.name">
      <span class="shrink-0 whitespace-nowrap">{{ $t("COMMON.FROM") }}:</span>
      <span v-tooltipable.collapsed="item.from" class="min-w-0 truncate">
        {{ item.sender.name }}
      </span>
    </template>
    <date-time
      :date="item.created_at"
      class="ml-auto shrink-0 whitespace-nowrap"
    />
  </div>
</template>
<script setup lang="ts">
import ProviderImage from "@/components/communicationLogs/communication/ProviderImage.vue";
import SmsStatus from "@/components/communicationLogs/communication/sms/SmsStatus.vue";
import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { SmsLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: SmsLogData;
}>();
</script>

<style scoped>
@reference "@/assets/tailwind.css";
</style>
